import { render, staticRenderFns } from "./lianluo.vue?vue&type=template&id=65f353aa&scoped=true&"
import script from "./lianluo.vue?vue&type=script&lang=js&"
export * from "./lianluo.vue?vue&type=script&lang=js&"
import style0 from "./lianluo.vue?vue&type=style&index=0&id=65f353aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f353aa",
  null
  
)

export default component.exports